<h2 class="popup-heading" mat-dialog-title>{{ data.roles ? 'Edit' : 'Add' }} Role</h2>
<form (ngSubmit)="submitForm($event)" [formGroup]="form">
  <mat-dialog-content class="mat-typography">
    <!-- <div class="errors">
      @for (error of errors | keyvalue; track error) {
        <span>{{ error.value }}</span>
      }
    </div> -->
    <mat-form-field appearance="fill">
      <mat-label>Name</mat-label>
      <input matInput [formControl]="form.controls.name" required>
    </mat-form-field>

    <div formArrayName="permissions">
      @for (permissions of form.controls.permissions.controls; track permissions; let pi = $index) {
        <div class="list-item">
          <div [formGroupName]="pi">
            <mat-icon>accessibility</mat-icon>
            <input matInput formControlName="permission_name" value="i" readonly>
            @for (access of permissions.value.permissionAccess; track access; let i = $index) {
              <div>
                <mat-radio-button [checked]="permissions.value.access == i" (change)="checkState(pi, i)"
                class="check-item" name="a{{pi}}">{{ access.name }}</mat-radio-button>
              </div>
            }
          </div>
        </div>
      }
      @if (this.errors) {
        <div class="error-box">
          All permissions access are required
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="cancel-popup" mat-button mat-dialog-close>Cancel</button>
    <button class="popup-save" mat-button type="submit" cdkFocusInitial [disabled]="processing">
      Save
      @if (processing) {
        <mat-icon>
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
      }
    </button>
  </mat-dialog-actions>
</form>
